import React from 'react'

import { Header, LenderNameText } from './ReadOnlyApplicationStatus.styled'

export interface ApplicationStatusHeaderTextProps {
    headerText: string
    lender: string
}

export default function ApplicationStatusHeaderText({
    headerText,
    lender,
}: Readonly<ApplicationStatusHeaderTextProps>) {
    return (
        <div>
            <Header>{headerText}</Header>
            <LenderNameText>{lender}</LenderNameText>
        </div>
    )
}
